import * as React from "react"

const SvgMapPin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 19.636q3.05-2.8 4.525-5.088Q18 12.261 18 10.486q0-2.726-1.738-4.463C14.524 4.286 13.683 4.286 12 4.286q-2.524 0-4.263 1.737Q6.001 7.761 6 10.486q0 1.774 1.475 4.062Q8.95 16.835 12 19.636m0 1.975q-.35 0-.7-.125a1.8 1.8 0 0 1-.625-.375A39 39 0 0 1 7.8 18.186q-1.25-1.425-2.087-2.763t-1.276-2.575Q4 11.611 4 10.486q0-3.75 2.412-5.975Q8.825 2.285 12 2.286c3.175.001 3.98.741 5.587 2.225Q20.001 6.736 20 10.486q0 1.125-.438 2.362-.437 1.237-1.274 2.575a21.7 21.7 0 0 1-2.088 2.763 39 39 0 0 1-2.875 2.925 1.8 1.8 0 0 1-.625.375 2.1 2.1 0 0 1-.7.125m0-9.325q.825 0 1.412-.588.588-.587.588-1.412t-.588-1.413A1.93 1.93 0 0 0 12 8.286q-.825 0-1.412.587A1.93 1.93 0 0 0 10 10.286q0 .825.588 1.412.587.588 1.412.588" />
  </svg>
)
export default SvgMapPin
